// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { StyledHeadingFourth } from './HeadingFourth.styles';
import { TAG_NAMES, TEXT_ALIGN, FONT_COLOR, HEADING_COLORS, TEXT_TRANSFORM } from '../Base/Base';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function HeadingFourth({ tagName, color, align, children, noMargins, className, textTransform, title }) {
  return (
    <StyledHeadingFourth
      title={title}
      tagName={tagName}
      color={HEADING_COLORS[color]}
      align={align}
      noMargins={noMargins}
      className={className}
      textTransform={textTransform}
    >
      {children}
    </StyledHeadingFourth>
  );
}

HeadingFourth.propTypes = {
  /** Font Color: primary, secondary, tertiary, quaternary */
  color: PropTypes.oneOf(FONT_COLOR),
  /** Element tag name: h1, h2, h3, h4, h5, h6, div, span, label, p, strong, li */
  tagName: PropTypes.oneOf(TAG_NAMES),
  /** Copy alignment: inherit, left, center, right, justify */
  align: PropTypes.oneOf(TEXT_ALIGN),
  /** Text Transform: none, capitalize, uppercase, lowercase, initial, inherit */
  textTransform: PropTypes.oneOf(TEXT_TRANSFORM),
  /** Copy/elements you want inside */
  children: ReactChildrenPropType,
  /** Remove default margins */
  noMargins: PropTypes.bool,
  /** Allows component to be overwritten by StyledComponents */
  className: PropTypes.string,
  title: PropTypes.string
};

HeadingFourth.defaultProps = {
  color: 'primary',
  align: 'left',
  tagName: 'div',
  textTransform: 'none',
  children: null,
  noMargins: false,
  className: '',
  title: undefined
};

export default HeadingFourth;
